import React, { useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMap, useMapEvents } from 'react-leaflet';
import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import { SearchHouseAddress } from '../Optics/LoadingData/LoadingDataTerritory';
import { WriteHousesEntranceCoordinate } from '../Optics/WriteData/WriteHouseEntrancesCoordinates';
import { DeleteHousesEntranceCoordinate } from '../Optics/WriteData/WriteHouseEntrancesCoordinates';
import L from 'leaflet';
import CustomSnackbar from '../Optics/Components/CustomSnackbar';
import { Snackbar } from '@mui/material';


const ModalDeleteHouse = ({ open, onClose, searchAddress }) => {
  const { showSnackbar, snackbarOpen, handleCloseSnackbar, snackbarMessage, snackbarClass } = CustomSnackbar();
  const [houseId, setHouseId] = useState(''); 
  const [house, setHouse] = useState([]);
  const houseData = house.length > 0 ? house[0] : null;
  
  // Обработчик изменения текста в поле ввода ID дома
  const handleHouseIdChange = (e) => {
    setHouseId(e.target.value);
  };

  const searchHouse = () => {    
    if (houseId.trim() !== '') { 
      SearchHouseAddress(houseId, setHouse );
    } else {
      showSnackbar(`Введите корректный ID дома!`, 'snackbarWarning');
    }
  };

  const handleDeleteHouse = () => {
    if (houseId.trim() !== '') {
      DeleteHousesEntranceCoordinate( houseData.id, showSnackbar, searchAddress);
    } else {
      showSnackbar(`Ошибка!`, 'snackbarWarning');
    }
  };

  // Обработчик закрытия окна
  const handleClose = () => {
    setHouseId(''); 
    setHouse([]);
    onClose();
  };

  return (
    <Dialog open={open} className="modalStyleUpTer">
      <DialogContent>
        <label style={{ color: '#dfab01', fontSize: '20px', fontFamily: 'unset' }}>Удалить координаты дома</label>
        <hr className='horizontalLineModalUpTer' />
        
        <input 
          className='inputAuth'
          type="number"
          placeholder="ID дома" 
          value={houseId} 
          onChange={handleHouseIdChange}
        />
        
        <button onClick={searchHouse} className='buttonIsHideModalUpTer' style={{ marginBottom: '10px', padding: "10px" }}>Поиск</button>
        <hr className='horizontalLineModalUpTer' />
        {houseData && (
          <>
            <label style={{ color: 'orange' }}>
              Адрес: <span style={{ color: '#c5c5c5' }}>ул. {houseData.street}, дом: {houseData.houseNumber}</span>
            </label>
            <br />
            <label style={{ color: 'orange' }}>
              Подъездов: <span style={{ color: '#c5c5c5' }}>{houseData.entrances}</span>
            </label>
            <br/>
            <button onClick={handleDeleteHouse} className='buttonIsDeleteModal2' style={{ marginLeft: '0px', padding: "5px" }}>Удалить</button>
          </>
          
        )}
        <hr className='horizontalLineModalUpTer' />

        
      </DialogContent>
      
      <DialogActions>
        <Button onClick={handleClose} class='buttonIsHideModalUpTer'>
          Закрыть
        </Button>
      </DialogActions>
       {/* Snackbar */}
       <Snackbar
          anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
          }}
          open={snackbarOpen}
          autoHideDuration={6000}
          onClose={handleCloseSnackbar}
          message={snackbarMessage}
          ContentProps={{
            style: {
              color: snackbarClass === 'snackbarOk' ? 'orange' : 'orange'
            }
          }}
        />
    </Dialog>
  );
};

export default ModalDeleteHouse;